import React, { Component } from "react";
import { connect } from "react-redux";
import WithAjax from "../common/helpers/WithAjax";
import { validateField } from "../../actions/helpers/validation";
import { setJumbotronTitle } from "../../actions/common";
import { fetchArticleEditDataSuccess, validateArticleEditField, submitArticleEditFields, clearArticleEditFields } from "../../actions/pages/article-page";
import InputField from "../common/form/InputField";
import RichTextarea from "../../pages/RichTextarea";
import DateTimeField from "../common/form/DateTimeField";
import CheckboxField from "../common/form/CheckboxField";
//import UploadFileField from "../../pages/UploadFileField";
import UploadFileField from "../../pages/UploadFileFieldArticle";
import EditForm from "../../pages/EditForm";
import ArticleDeleteButton from "./ArticleDeleteButton";

class ArticleEditForm extends Component {
  constructor() {
    super();

    this.state = {
      formVisible: false,
      imageError: null,
      croppedImage: null
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.getCroppedImage = this.getCroppedImage.bind(this);

    this.articleBaseUrl = "articles/";
  }

  componentDidMount() {
    let id = parseInt(this.props.match.params.id, 10);

    this.props.clearArticleEditFields();

    if (Number.isInteger(id)) {
      let url = this.articleBaseUrl + id;

      this.props.ajax.get(url, true, (data) => {
        this.props.fetchArticleEditDataSuccess(data);
        this.props.setJumbotronTitle(data.Title);

        this.setState({ formVisible: true });
      });
    } else {
      this.props.setJumbotronTitle("Create");
      this.setState({ formVisible: true });
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    let validatedFields = this.props.fields.map((field) => validateField(field));

    if (!this.validImageUpload()) {
      return;
    }

    let isValid = validatedFields.filter((field) => field.errors.length > 0).length > 0 ? false : true;

    this.props.submitArticleEditFields(validatedFields);

    if (!isValid) {
      return;
    }

    let data = {};
    this.props.fields.forEach((field) => {
      if(field.name == 'ImageFile'){
        data[field.name] = this.state.croppedImage;
      }else{
        data[field.name] = field.value;
      }
    });

    let id = parseInt(this.props.match.params.id, 10);


    if (Number.isInteger(id)) {
      this.updateArticle(id, data);
    } else {
      this.createArticle(data);
    }
  }

  validImageUpload() {
    var imageFile = this.props.fields.find((field) => {
      return field.name === "ImageFile";
    });
    var imageUrl = this.props.fields.find((field) => {
      return field.name === "ImageUrl";
    });

    if (!imageFile.value && !imageUrl.value) {
      this.setState({ imageError: "Article image is required." });
      return false;
    }

    this.setState({ imageError: "" });
    return true;
  }

  createArticle(data) {
    let formData = this.convertToFormData(data);

    this.props.ajax.post(this.articleBaseUrl, formData, null, () => {
      this.props.history.push("/news");
    });
  }

  updateArticle(id, data) {
    let url = this.articleBaseUrl + id;
    let formData = this.convertToFormData(data);

    this.props.ajax.put(url, formData, null, () => {
      this.props.history.push("/news");
    });
  }

  convertToFormData(data) {
    var formData = new FormData();
    formData.append("BodyJson", JSON.stringify(data));
    formData.append("ImageFile", data["ImageFile"]);

    return formData;
  }

  getCroppedImage(file){
    this.setState({croppedImage:file})
  }

  render() {
    let fields = this.props.fields;

    if (!this.state.formVisible) {
      return <div />;
    }

    return (
      <EditForm title="Edit article" description="">
        {fields[0] && <InputField field={fields[0]} validate={this.props.validateArticleEditField} />}
        {fields[1] && <RichTextarea field={fields[1]} validate={this.props.validateArticleEditField} />}
        {fields[2] && <DateTimeField field={fields[2]} validate={this.props.validateArticleEditField} />}
        {fields[3] && <CheckboxField field={fields[3]} validate={this.props.validateArticleEditField} />}
        {fields[4] && <UploadFileField  onSelectedImage={() => false} field={fields[4]} validate={this.props.validateArticleEditField} croppedImage={this.getCroppedImage} />}
        {this.state.imageError && <div className="form-text text-danger mb-2">{this.state.imageError}</div>}
        {fields[5] && fields[5].value && (
          <div>
            <div>Current image:</div>
            <img src={fields[5].value} style={{ maxHeight: "100px", margin: "5px" }} alt="" />
          </div>
        )}

        {fields && (
          <div className="form-group" style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
            <button className="btn btn-primary btn-rounded" type="submit" onClick={this.handleSubmit}>
              Save
            </button>
            <ArticleDeleteButton articleId={parseInt(this.props.match.params.id, 10)} />
          </div>
        )}
      </EditForm>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  fields: state.articleEditForm.fields,
  isLoading: state.common.isLoading,
});
const mapDispatchToProps = (dispatch) => ({
  fetchArticleEditDataSuccess: (editData) => dispatch(fetchArticleEditDataSuccess(editData)),
  submitArticleEditFields: (fields) => dispatch(submitArticleEditFields(fields)),
  validateArticleEditField: (value, field) => dispatch(validateArticleEditField(value, field)),
  clearArticleEditFields: () => dispatch(clearArticleEditFields()),
  setJumbotronTitle: (title) => dispatch(setJumbotronTitle(title)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithAjax(ArticleEditForm));
